import { SortPage, SortDirection } from './../../../models/pagination/sort-page';
import { DeletePartyComponent } from './delete-party/delete-party.component';
import { UpdatePartyComponent } from './update-party/update-party.component';
import { PartyService } from '../../../services/api/party/party.service';
import { Party } from '../../../models/party-manager/party';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, PageEvent } from '@angular/material';
import { SearchObject } from 'src/app/models/pagination/search-object';

@Component({
  selector: 'app-party',
  templateUrl: './party.component.html',
  styleUrls: ['./party.component.scss']
})
export class PartyComponent implements OnInit, AfterViewInit {

  @ViewChild(MatSort, { static: false }) sort: MatSort;

  elements: Party[]

  resultsLength:number = 0;

  searchObject:SearchObject = new SearchObject(10,0); 
  sortPage: SortPage= new SortPage("createdAt",SortDirection.DESC);

  tooltip = {
    refresh: '',
    edit: '',
    delete: ''
  }

  displayedColumns: string[] = [
    'name',
    'namingId',
    'spec',
    'actions'
    ];

  form: FormGroup;

  constructor(
    private translate: TranslateService,
    private partyService:PartyService,
    private router: Router,
    private dialog: MatDialog,
     ) { }
  ngAfterViewInit(): void {
   this.sort.sortChange.subscribe(data =>{
    this.sortPage = new SortPage(data['active'],SortDirection[data['direction'].toUpperCase()] as SortDirection);
    this.searchObject.sort= this.sortPage;
    this.getParties()
   });
  }

  ngOnInit() {
    this.getParties()
    this.initTooltips();
  }

  
  private initTooltips() {
    this.translate.get('DUMMY.key').subscribe((translated: string) => {
      this.tooltip.refresh = this.translate.instant('TOOLTIPS.refreshResults');
      this.tooltip.edit = this.translate.instant('TOOLTIPS.updateParty');
      this.tooltip.delete = this.translate.instant('TOOLTIPS.deleteParty');
    });
  }

  getParties(){
    this.searchObject.sort = this.sortPage
    this.partyService.get(this.searchObject).subscribe(data =>{
      this.elements = data.elements
      this.resultsLength = data.totalElements
    });
    
  }

  delete(party:Party){
    const matDialogRef = this.dialog.open(DeletePartyComponent, {
      data: {
        party
      }
    });
    matDialogRef.afterClosed().subscribe(()=>this.getParties());
  }

  update(party:Party){
    const matDialogRef = this.dialog.open(UpdatePartyComponent, {
      data: {
        party
      },
      disableClose: true,
      hasBackdrop: true,
      width: '75%',
      maxHeight: '70%',
      restoreFocus: false,
      autoFocus: false
    });
    matDialogRef.afterClosed().subscribe(()=>this.getParties());
  }

  goToNewParty(){
    this.router.navigate([`/provision/management/party/new-party`]);
  }

  getData(event?:PageEvent){
    this.searchObject.page=event.pageIndex;
    this.searchObject.size= event.pageSize;
    this.getParties();
  }

  search(){
    this.getParties();
  }

}
